const GAP = 0; // Mindestabstand zwischen Min & Max, falls gewünscht

document.querySelectorAll(".range-slider").forEach((slider) => {
  const minInput = slider.querySelector(".range-min");
  const maxInput = slider.querySelector(".range-max");
  const progress = slider.querySelector(".progress");
  const minLabel = slider.querySelector(".range-min-value");
  const maxLabel = slider.querySelector(".range-max-value");
  const unit = slider.dataset.unit || ""; // z.B. " m²" nur beim Flächen-Slider

  if (!minInput || !maxInput || !minLabel || !maxLabel) return;

  const minAttr = parseFloat(minInput.min) || 0;
  const maxAttr = parseFloat(minInput.max);

  function update(e) {
    let minVal = parseFloat(minInput.value);
    let maxVal = parseFloat(maxInput.value);

    // Mindestabstand erzwingen (optional)
    if (maxVal - minVal < GAP) {
      if (e && e.target === minInput) {
        minVal = maxVal - GAP;
        minInput.value = minVal;
      } else {
        maxVal = minVal + GAP;
        maxInput.value = maxVal;
      }
    }

    const range = maxAttr - minAttr;
    const minPercent = ((minVal - minAttr) / range) * 100;
    const maxPercent = ((maxVal - minAttr) / range) * 100;

    // Progress-Balken nur in DIESEM Slider
    if (progress) {
      progress.style.left = minPercent + "%";
      progress.style.right = (100 - maxPercent) + "%";
    }

    // Labels aktualisieren + positionieren (nur in DIESEM Slider)
    minLabel.textContent = minVal + unit;
    maxLabel.textContent = maxVal + unit;

    minLabel.style.left = minPercent + "%";
    maxLabel.style.left = maxPercent + "%";
  }

  minInput.addEventListener("input", update);
  maxInput.addEventListener("input", update);

  // Initial setzen
  update();
});
